import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { ImagePlugin } from 'bootstrap-vue'
import axios from 'axios'
import './assets/css/main.css'

Vue.config.productionTip = false
// Vue.prototype.$eventBus  = new Vue()
Vue.prototype.$axios = axios

Vue.use(BootstrapVue)
Vue.use(ImagePlugin)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
